const baseApiReferenceUrl = 'https://www.solveigmm.com/en/support/doc/html-5-video-editor/api-reference.html'

export const callBackEvents = `${baseApiReferenceUrl}#CallBack_events`
export const customization = `${baseApiReferenceUrl}#Customization`
export const overrideMediaAssets = `${baseApiReferenceUrl}#Custom_urls_spec`
export const generateMediaInfo = `${baseApiReferenceUrl}#minfo_api`
export const apiUsers = `${baseApiReferenceUrl}#Create_User`
export const createUserWithSecreteApiKey = `${baseApiReferenceUrl}#create_user_with_secreteapikey`

